import { Typography } from "@material-ui/core";
import { Fragment } from "react";
import { useTranslate } from "react-admin";
import { Widget } from "../widgets/Widget";
import { VehicleWidgetProps } from "./VehicleWidgetProps";

export const VehicleInfoWidget = ({
  vehicle,
  ...props
}: VehicleWidgetProps) => {
  const translate = useTranslate();
  const data = Object.getOwnPropertyNames(vehicle)
    .filter((x) => !x.toUpperCase().endsWith("ID"))
    .map((x) => ({ label: x, value: (vehicle as any)[x] }));
  return (
    <Widget {...props}>
      <div className="categories">
        <div className="info-wrapper info-wrapper-2-3">
          {data.map((x) => (
            <Fragment key={x.label}>
              <div className="info-label">
                <Typography variant="body1">
                  {translate(
                    `resources.maintenance-dashboard.labels.${x.label}`
                  )}
                </Typography>
              </div>
              <div className="info-value">
                <Typography variant="body1">{x.value ?? "-"}</Typography>
              </div>
            </Fragment>
          ))}
        </div>
      </div>
    </Widget>
  );
};
